import { API_BASE_URL } from "@/config";
import GlobalSearch from '@/components/GlobalSearch/GlobalSearch.vue';
import { getClientDefaultRoute, getBackButtonLabel, getClientFromDomain } from '@/utils/redirects.js';

export default {
  components: {
    GlobalSearch
  },
  data: () => ({
    user_info: {}
  }),
  computed: {
    page_title() {
      switch (this.$route.name) {
        case 'project_table':
          return 'Projects';
        case 'project_dashboard':
          return 'Project Dashboard';
        case 'service_dashboard':
          return 'Services';
        case 'client_services':
          return 'Select Services';
        case 'workflow_services':
          return 'Your Services';
        case 'service_rules':
          return 'Service Rules'
        case 'create_workflows':
          return 'Workflows';
        case 'question_management':
          return 'Question Management';
        case 'form_management':
          return 'Form Management';
        case 'manage_form':
          return 'Manage Form';
        case 'template_management':
          return 'Template Management';
        case 'view_service':
          return 'View Service';
        case 'reasons_for_usage':
          return 'Reasons For Usage';
        case 'arrange_workflow':
          return 'Workflows';
        case 'upload_consent':
          return 'Terms and Conditions';
        case 'confirm_workflow':
          return 'Workflow Details';
        case 'client_view_workflow':
        case 'admin_view_workflow':
          return 'View Workflow';
        case 'edit_workflow':
          return 'Edit Workflow';
        case 'behalf_application':
          return 'Behalf Application';
        case 'batch_processing':
          return 'Batch Processing';
        case 'view_batches':
          return 'View Batches';
        case 'workflow_router':
            return 'Advanced Settings';
        case 'instant_verify':
          return 'Instant Verify';
        case 'instant_services':
          return 'Instant Services';
        case 'services':
          return 'Your Services';
        case 'assigned_workflows':
          return 'Dashboard'
        case 'customer_profile':
          return 'Profile'
        case 'verify_logs':
          return 'Service Logs';
        case 'client_admin':
          return 'Users';
        case 'create_asset':
          return 'Asset';
        case 'view_asset':
          return 'Asset Information';
        case 'customer_data':
          return 'View Customer in Your Workflow'
        case 'conditional_questions':
          return 'Add Conditional Questions'
        case 'template_configuration':
          return 'Template Configuration';
        case 'view_client_admin':
          return 'Client Admin Details'
        case 'view_client':
          return 'Client Details'
        case 'utilize_service':
          return 'Service Utilization'
        case 'customer_applications':
          return 'Customer Applications'
        case 'view_customer':
          return 'Customer Information'
        case 'system_communications':
          return 'System Communications'
        case 'data_hub':
          return 'Data Hub'
        case 'thank_you':
          return 'Thank You Page'
        case 'toolbox':
          return 'Toolbox'
        case 'workbench':
          return 'Workbench'
        case 'workflow_templates':
          return 'Workflow Templates'
        default:
          return this.getDefaultPageTitle();
      }
    },
    backButtonLabel() {
      return getBackButtonLabel(this.user_info.user_role);
    },
    isToolboxClient() {
      const client = getClientFromDomain();
      const toolboxClients = ['swift', 'suzuki', 'mobiafrica'];
      return toolboxClients.includes(client);
    },
    backToWorkflowsLabel() {
      if (this.isToolboxClient && this.user_info.user_role === 'Client') {
        return 'Back to Toolbox';
      }
      return 'Back to Workflows';
    }
  },
  methods: {
    getDefaultPageTitle() {
      // Get client from domain
      const domain = window.location.hostname;

      // Client-specific default titles
      if (domain.includes('verify')) {
        return 'Verify Portal';
      }

      // Generic fallback based on user role
      if (this.user_info.user_role === 'SystemAdmin') {
        return 'Admin Portal';
      } else if (this.user_info.user_role === 'ClientAdmin') {
        return 'Client Portal';
      } else if (this.user_info.user_role === 'Customer') {
        return 'Dashboard';
      }
      return 'Portal';
    },
    get_user_information() {
      const TOKEN = localStorage.getItem('token');
      const GET_USER_INFORMATION_API = `${API_BASE_URL}/verify_api/system_management_api/get_user_api/`;

      $.ajax({
        url: GET_USER_INFORMATION_API,
        method: 'GET',
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        success: (response) => {
          this.user_info = response.data;
        },
        error: () => {
        }
      });
    },
    get_initial(name) {
      if (typeof name == 'string' && name.length > 0) {
        return name.charAt(0).toUpperCase();
      } else {
        return '';
      }
    },
    go_back() {
      this.$router.push(getClientDefaultRoute(this.user_info.user_role));
    },
    go_back_to_workflows() {
      if (this.isToolboxClient && this.user_info.user_role === 'Client') {
        this.$router.push({ name: 'toolbox' });
      } else {
        this.$router.push({ name: 'project_dashboard' });
      }
    },
    go_back_to_assigned_workflows() {
      this.$router.push({ name: 'assigned_workflows' })
    },
    go_back_to_services() {
      this.$router.push({ name: 'service_dashboard' });
    },
    hide_back_icon() {
      const current_route = this.$route.name;
      const hide_on_routes = ['project_table', 'workbench', 'create_asset', 'assigned_workflows', 'customer_profile'];
      return !hide_on_routes.includes(current_route);
    },
    hide_burger_icon() {
      const current_route = this.$route.name;
      const hide_on_routes = ['assigned_workflows', 'customer_profile'];
      return !hide_on_routes.includes(current_route);
    },
    show_back_to_workflows() {
      const current_route = this.$route.name;
      const show_on_routes = ['edit_workflow', 'behalf_application', 'client_view_workflow', 'admin_view_workflow', 'workflow_services', 'service_rules', 'arrange_workflow', 'upload_consent', 'reasons_for_usage', 'confirm_workflow', 'workflow_router'];
      return show_on_routes.includes(current_route);
    },
    show_back_to_services() {
      const current_route = this.$route.name;
      const show_on_routes = ['view_service']; // Add routes where you want to show "Back to Services"
      return show_on_routes.includes(current_route);
    },
    toggle_sidebar() {
      this.$emit('toggle-sidebar');
    },
    redirect_to_customer_profile() {
      if (this.$route.name === 'assigned_workflows') {
        this.$router.push({ name: 'customer_profile' });
      }
    },
    admin_back_to_workflows() {
      const current_route = this.$route.name;
      const show_on_routes = ['view_single_workflow'];
      return show_on_routes.includes(current_route);
    },
    admin_go_back_to_workflows() {
      this.$router.push({ name: 'view_workflow_status' });
    },
  },
  mounted() {
    this.get_user_information();
  }
}
